import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
  skipStatus: false,
};

const companySkipSlice = createSlice({
  name: "companySkip",
  initialState: INITIAL_STATE,
  reducers: {
    skipOpen: (state) => {
      state.skipStatus = true;
    },
    skipFalse: (state) => {
      state.skipStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { skipFalse, skipOpen } = companySkipSlice.actions;
export default companySkipSlice.reducer;
